module.exports = __webpack_public_path__ + "static/media/x.df13156b.svg";